export default {
    loggedIn: false,
    loggedInUser: {
        avatar: undefined,
        name: ''
    },
}
